<p-table [value]="options" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Is Default</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-opt>
        <tr>
            <td>{{opt.name}}</td>
            <td>
              <p-radioButton [disabled]="opt.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="opt.isDefault"
               (onClick)="setDefault(opt)"></p-radioButton>
                {{opt.isDefault?answertypeConstants.Yes: answertypeConstants.No}}
            </td>
        </tr>
    </ng-template>
</p-table>